module.exports = __webpack_public_path__ + "static/rowIcon2.19be579a.svg";